<template>
  <form @keyup.enter="saveDataAndRedirect()" @submit.prevent="saveDataAndRedirect()">
    <div class="form-section">
      <label class="form-label">
        <span class="icon">
          <svg>
            <use xlink:href="#icon-folder-small" />
          </svg>
        </span>
        {{ $t('step1GetTemplate') }}
      </label>
      <img src="@/assets/img/example_xls.png" alt="">
      <div class="template-hint">
        <div><strong>Username</strong> — {{ $t('usernameHelp') }}</div>
        <div><strong>Car numbers</strong> — {{ $t('carNumbersHelp') }}</div>
        <div><strong>Attached accounts</strong> — {{ $t('attachedAccountsHelp') }}</div>
        <div><strong>Access groups</strong> — {{ $t('accessGroupsHelp') }}</div>
      </div>
    </div>
    <CamsButton type="button" class="template-button" @click="getXlsxFileTemplate">
      {{ $t('downloadTemplateXLSX') }}
    </CamsButton>
    <div class="form-section">
      <label class="form-label">
        <span class="icon">
          <svg>
            <use xlink:href="#icon-clip" />
          </svg>
        </span>
        {{ $t('step2ChooseFile') }}
      </label>
      <input
        ref="fileInput"
        type="file"
        style="display:none"
        accept=".csv, .xlsx"
        onclick="this.value=null"
        @change="uploadCsvFile"
      >
      <CamsButton
        v-model="dataForm.file"
        class="upload-button"
        type="button"
        @click="$refs.fileInput.click()"
      >
        {{ $t('selectFile') }}
      </CamsButton>
      <div v-if="dataForm.file" class="file-name">
        <label class="form-label">
          <span class="icon icon-file">
            <svg>
              <use xlink:href="#icon-file" />
            </svg>
          </span>
          {{ $t('selectedFile') }}  {{ dataForm.file.name }}   </label>
      </div>
    </div>

    <div v-if="dataForm.file.name" class="buttons-group buttons-group--align-left template-button" style="margin-top: 6px">
      <CamsButton priority="primary" type="submit">
        {{ $t('uploadFile') }}
      </CamsButton>
    </div>

    <SpinnerLoadingModal v-if="isLoading" />
  </form>
</template>



<script>
import {createEntityMixin} from "@/components/pacs/mixins.js";
import {
  ACTION_CREATE_EMPLOYEE_FROM_FILE,
  ACTION_GET_TEMPLATE_FILE_CSV, ACTION_GET_TEMPLATE_FILE_XLSX,
} from "@/store/pacs/employees/index.js";
import {actionsWithPhotosMixin} from "@/components/pacs/employess/mixins.js";
import {downloadCSV, downloadXLSX} from "@/utils/helpers.js";

/**
 * Компонент диалога загрузки сотрудников из файла.
 */
export default {
  mixins: [createEntityMixin, actionsWithPhotosMixin],
  data() {
    return {
      actionForSave: `pacs/employees/${ACTION_CREATE_EMPLOYEE_FROM_FILE}`,
      dataForm: {
        file: "",
      },
    };
  },
  methods: {
    async getXlsxFileTemplate() {
      const fileData = await this.$store.dispatch(`pacs/employees/${ACTION_GET_TEMPLATE_FILE_XLSX}`);
      downloadXLSX("template.xlsx", fileData);
    },
    async getFileTemplate() {
      this.templateHeaders = await this.$store.dispatch(`pacs/employees/${ACTION_GET_TEMPLATE_FILE_CSV}`);
      downloadCSV("template", this.templateHeaders.data);
    },
    uploadCsvFile(event) {
      this.dataForm.file = event.target.files[0];
    },
    async saveDataAndRedirect() {
      this.isLoading = true;
      try {
        await this.saveData();
        this.$notify({
          type: "success",
          group: "main",
          text: this.$t('successFileUploaded'),
        });
        this.closeDialog();
      } catch (error) {
        this.$notify({
          type: "error",
          group: "main",
          duration: 12000,
          text: `${this.$t('errorFileUpload')} ${error.fields.file}`,
        });
      }
      this.isLoading = false;

    },
  },
};
</script>
<style scoped>
.form-section {
  margin-top: 20px;
}
.form-label {
  font-weight: 600;
  margin-bottom: 5px;
  display: block;
}
.file-name {
  margin-top: 16px;
}
.template-button {
  margin-left: 50px;
}
.upload-button {
  margin-left: 55px;
}
.icon {
  display: inline-block;
  vertical-align: middle;
  margin-right: 8px;
  margin-bottom: 12px;
}
.icon-file {
  margin-top: 6px;
}
.template-hint {
  margin-top: 10px;
  margin-bottom: 10px;
  font-size: 13px;
  color: #555;
  background-color: #f9fafb;
  padding: 10px 12px;
  border-left: 3px solid #2f84f8;
  border-radius: 4px;
  line-height: 1.5;
}
.template-hint strong {
  color: #111;
}
</style>
